module.exports = __webpack_public_path__ + "static/img/banner_pressCenter.1094147.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/banner_pressCenter.png
// module id = JrTh
// module chunks = 15